import React from 'react'
import { Form, InputNumber } from 'antd'
import Access from '../../../../../../components/access/Access'
import { Perm, State } from '../../../../../../../../constants/assignment-permissions'
import Text from 'antd/es/typography/Text'

const TestMemoryLimit = ({ initialValue }) => {
    return (
        <Form.Item
            label='Memory Limit, KB'
            name='memoryLimit'
            rules={[
                {
                    type: 'number',
                    min: 2048,
                    max: 5120000,
                },
            ]}
            initialValue={128000}
        >
            <Access
                rules={[Perm.CAN_EDIT, State.NOT_PROCESSING, State.NOT_MBA, State.UNPUBLISHED]}
                fallback={<Text>{initialValue}</Text>}
            >
                <InputNumber step={1024} />
            </Access>
        </Form.Item>
    )
}

export default TestMemoryLimit
